// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import faceSmileIcon from "@/assets/icons/face-smile.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FaceSmileIconProps = Omit<IconProps, "name">;

export function FaceSmileIcon(props: FaceSmileIconProps): React.ReactNode {
  return <Icon name={faceSmileIcon} {...props} />;
}
